import React$1 from 'react';

const Instagram = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, /*#__PURE__*/React$1.createElement("path", {
  fill: "#FF005F",
  fillRule: "evenodd",
  d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm0 14a6 6 0 100 12 6 6 0 000-12zm0 2c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm6.17-3.733a1 1 0 100 2 1 1 0 000-2zM25.922 9H14.077A5.077 5.077 0 009 14.077v11.846A5.077 5.077 0 0014.077 31h11.846A5.077 5.077 0 0031 25.923V14.077A5.077 5.077 0 0025.923 9z"
}));

export default Instagram;
